import { HttpEvent, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { finalize, Observable, ReplaySubject, share } from 'rxjs';

const inFlightGets = new Map<string, Observable<HttpEvent<unknown>>>();

function coalescingKey(req: HttpRequest<unknown>): string {
  return `${req.method} ${req.urlWithParams} ${req.headers.get('x-shop') ?? ''}`;
}

export const getCoalescingInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.method !== 'GET') {
    return next(req);
  }

  const key = coalescingKey(req);
  const pending = inFlightGets.get(key);
  if (pending) {
    return pending;
  }

  const shared = next(req).pipe(
    finalize(() => inFlightGets.delete(key)),
    share({
      connector: () => new ReplaySubject<HttpEvent<unknown>>(1),
      resetOnRefCountZero: true,
      resetOnComplete: true,
      resetOnError: true,
    }),
  );

  inFlightGets.set(key, shared);
  return shared;
};
